import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=5914fff8&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5914fff8')) {
      api.createRecord('5914fff8', component.options)
    } else {
      api.reload('5914fff8', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=5914fff8&", function () {
      api.rerender('5914fff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4KSx5UDvVm1hX/JS/ImageCarousel.vue"
export default component.exports